/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
// import env from '@/config/env';

export const Types = {
  UF_ADD: 'UF_ADD',
  UF_CHANGE: 'UF_CHANGE',
};

export default {
  namespaced: true,
  state: {
    uf: null,
    ufId: null,
  },
  getters: {
    uf: state => state.uf,
    ufId: state => state.ufId,
  },
  mutations: {
    [Types.UF_ADD](state, payload) {
      state.uf = payload.uf;
      state.ufId = payload.ufId;
    },
    [Types.UF_CHANGE](state, payload) {
      state.uf = payload.uf;
      state.ufId = payload.ufId;
    },
  },
  actions: {
    async addUF({ commit, rootGetters, dispatch }, payload) {
      try {
        const ufs = await rootGetters['uf/ufs'];
        const [ufId] = ufs.filter(uf => uf.sigla === payload).map(item => item.id);
        window.localStorage.setItem('@vivo.consulta:UF', payload);
        commit(Types.UF_ADD, { uf: payload, ufId });
        return ufId;
      } catch (e) {
        dispatch(
          'error/setError',
          { message: 'Não foi possível attribuir uma UF ao usuário' },
          { root: true },
        );
      }
    },
    async changeUF({ commit, rootGetters, dispatch }, payload) {
      try {
        const ufs = await rootGetters['uf/ufs'];
        const [ufId] = ufs.filter(uf => uf.sigla === payload).map(item => item.id);
        window.localStorage.setItem('@vivo.consulta:UF', payload);
        commit(Types.UF_CHANGE, { uf: payload, ufId });
        return ufId;
      } catch (e) {
        dispatch(
          'error/setError',
          { message: 'Não foi possível attribuir uma UF ao usuário' },
          { root: true },
        );
      }
    },
  },
};
